import { GenericFieldFactory } from "../../../Common/_generics/GenericFieldFactory";

export const BaseCustomizationStore = GenericFieldFactory(
    "LOCATION_CUSTOMIZATION",
    null,
);